import { Box, Typography, Checkbox } from '@mui/material';
import { useAtomValue, useSetAtom } from 'jotai';
import { allSitesFiberSitePlanning, selectedReportFields } from '../../common/atom/atoms';
import React, { useState, useEffect } from 'react';
import { getFieldDisplayName } from '../../common/functions/fieldNameMapping.function';
import { useFiberDashboard } from './context/fiberDashboardContext';

export default function SelectFieldsGenerateReportFiber() {
  const { dashboardData } = useFiberDashboard();
  const setSelectedFields = useSetAtom(selectedReportFields);
  const checkboxItems =
    Array.isArray(dashboardData) && dashboardData.length > 0 ? Object.keys(dashboardData[0]) : [];

  const [checked, setChecked] = useState([]);

  // Reset checked when items change
  useEffect(() => {
    setChecked([]);
    setSelectedFields([]);
  }, [checkboxItems.join(','), setSelectedFields]);

  // Update global state when checked items change
  useEffect(() => {
    setSelectedFields(checked);
  }, [checked, setSelectedFields]);

  const allChecked = checked.length === checkboxItems.length && checkboxItems.length > 0;
  const isIndeterminate = checked.length > 0 && checked.length < checkboxItems.length;

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setChecked(checkboxItems);
    } else {
      setChecked([]);
    }
  };

  const handleCheck = (label) => (event) => {
    if (event.target.checked) {
      setChecked((prev) => [...prev, label]);
    } else {
      setChecked((prev) => prev.filter((item) => item !== label));
    }
  };

  return (
    <>
      <Box
        sx={{
          px: 3.5,
          py: 2,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          gap: 1.25,
        }}
      >
        <Box
          sx={{
            width: 199.5,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 1.5,
          }}
        >
          <Box sx={{ width: 24, height: 24, position: 'relative' }}>
            <Checkbox
              sx={{
                p: 0,
                marginLeft: '3px',
                color: '#D0D5DD',
                '&.Mui-checked': {
                  color: '#BD1D23',
                },
              }}
              checked={allChecked}
              indeterminate={isIndeterminate}
              onChange={handleSelectAll}
            />
          </Box>
          <Typography
            sx={{
              color: '#1D242E',
              fontSize: 16,
              fontFamily: 'Roboto',
              fontWeight: 500,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            Select all
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          alignSelf: 'stretch',
          px: 3.5,
          pb: 2,
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: 3,
        }}
      >
        {checkboxItems.map((label, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              // minWidth: 200, // Remove or adjust this if needed
            }}
          >
            <Checkbox
              sx={{
                p: 0,
                color: '#D0D5DD',
                '&.Mui-checked': {
                  color: '#BD1D23',
                },
              }}
              checked={checked.includes(label)}
              onChange={handleCheck(label)}
            />
            <Typography
              sx={{
                color: '#1D242E',
                fontSize: 16,
                fontFamily: 'Roboto',
                fontWeight: 300,
              }}
            >
              {getFieldDisplayName(label)}
            </Typography>
          </Box>
        ))}
      </Box>
    </>
  );
}
